export default __webpack_public_path__ + "static/media/file-pdf.8dde7499.svg";